/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 7:17 PM
 * To change this template use File | Settings | File Templates.
 *
 * the CollectionView used to render the whole control
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var SingleSelectCategoriesView = require("ui/single-select/js/views/SingleSelectCategoryView");

    var SingleSelectCollectionView = Marionette.CollectionView.extend({
        itemView: SingleSelectCategoriesView,
        initialize: function(options) {
            this.logger = Logger.getLogger('SingleSelect');
            this.vent = options.vent;

            this.itemViewOptions = {};
            this.itemViewOptions.vent = this.vent;
            this.itemViewOptions.selectedItems = options.selectedItems;
        }
    });


    return SingleSelectCollectionView;
});